import { apiClient } from 'src/utils/api-client';
import type { ApiClient } from 'src/utils/api-client';
import { octaneClient } from 'src/utils/octane-client';
import {
  NewOwnerOnboardingModel,
  OwnerOnboardingModel,
  UnitListingDetailsModel,
} from './models';
import {
  CreateHomeCommand,
  HomeDto,
  HomeDtoPaginatedResponseDto,
} from './octane/models.homes';

export function fetchOnboardingPropertiesService(
  client: ApiClient = apiClient,
) {
  return client.get<OwnerOnboardingModel>('/homeowners/properties/onboarding');
}

export function createOnboardingPropertiesService(
  ownerOnboardingModel: NewOwnerOnboardingModel,
) {
  return apiClient.post<OwnerOnboardingModel>(
    '/homeowners/properties/onboarding',
    ownerOnboardingModel,
  );
}

export function createXPropertyService(xProperty: CreateHomeCommand) {
  return octaneClient.post<HomeDto>('/v1/homes', xProperty);
}

export function fetchXHomesService() {
  return octaneClient.get<HomeDtoPaginatedResponseDto>('/v1/homes');
}

// The fields the homeowner-fixes-tracking page reads off this response. Without
// a type argument `get` resolves to `{}`, so destructuring any of them failed.
type HomeownerImprovementFixing = {
  estimatedHomeownerFixingCompletionDate?: string;
  maintenanceId?: string;
  reportId?: string;
  status?: string;
};

export function fetchHomeownerImprovementFixing(
  unitId: string,
  client: ApiClient = apiClient,
) {
  return client.get<HomeownerImprovementFixing>(
    `/homeowners/units/${unitId}/homeowner-fixing`,
  );
}

export const completeHomeownerFixing = (
  maintenanceGroupId: string,
  client: ApiClient = apiClient,
) => {
  return client.post(
    `/maintenance/${maintenanceGroupId}/complete-homeowner-fixing`,
  );
};

export const confirmHomeownerFixing = (
  maintenanceGroupId: string,
  client: ApiClient = apiClient,
) => {
  return client.post(
    `/maintenance/${maintenanceGroupId}/confirm-homeowner-fixing-date`,
  );
};

export const setHomeownerFixingDate = (
  maintenanceGroupId: string,
  data: { estimatedHomeownerFixesCompletionDate: string },
  client: ApiClient = apiClient,
) => {
  return client.put(
    `/maintenance/${maintenanceGroupId}/set-homeowner-fixing-date`,
    data,
  );
};

export const fetchHome = (homeId: string, client: ApiClient = apiClient) => {
  return client.get<UnitListingDetailsModel>(`/homes/${homeId}`);
};
